import { themeGet } from '@styled-system/theme-get';
import styled from 'styled-components';

const MomentsArea = styled.section`
  position: relative;
  max-width: 1170px;
  margin: 0 auto;
`;

export const MomentsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 28px;
  @media (max-width: 991px) {
    grid-template-columns: 1fr;
    gap: 20px;
    max-width: 520px;
    margin: 0 auto;
  }
`;

export const MomentCard = styled.article`
  background: ${themeGet('colors.white')};
  border: 1px solid ${themeGet('colors.borderColor')};
  border-radius: 16px;
  padding: 32px 28px;
  height: 100%;
  @media (max-width: 520px) {
    padding: 24px 20px;
  }
  figure {
    margin: 0 0 20px;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${themeGet('colors.secondary')};
    color: ${themeGet('colors.headingColor')};
    svg {
      width: 28px;
      height: 28px;
    }
  }
  h3 {
    color: ${themeGet('colors.headingColor')};
    font-weight: 700;
    font-size: 20px;
    line-height: 1.35;
    letter-spacing: -0.02em;
    margin-bottom: 12px;
    @media (max-width: 520px) {
      font-size: 18px;
    }
  }
  p {
    color: ${themeGet('colors.textColor')};
    font-weight: 500;
    font-size: 15px;
    line-height: 1.7;
    margin-bottom: 0;
  }
`;

export const SectionHeading = styled.div`
  --marginBottom: 48px;
  margin-bottom: var(--marginBottom);
  text-align: center;
  max-width: 720px;
  margin-left: auto;
  margin-right: auto;
  @media (max-width: 1024px) {
    --marginBottom: 40px;
  }
  @media (max-width: 600px) {
    --marginBottom: 32px;
  }
  .subtitle {
    color: ${themeGet('colors.secondaryDark')};
    font-size: 16px;
    font-weight: 700;
    line-height: 22px;
    letter-spacing: -0.005em;
    margin-bottom: 10px;
  }
  h2 {
    color: ${themeGet('colors.headingColor')};
    font-weight: 800;
    line-height: 1.25;
    letter-spacing: -0.5px;
    margin-bottom: 14px;
    @media (min-width: 1024px) {
      font-size: 28px;
    }
    @media (max-width: 600px) {
      font-size: 24px;
    }
    @media (max-width: 520px) {
      font-size: 20px;
    }
  }
  .description {
    color: ${themeGet('colors.textColor')};
    font-weight: 500;
    font-size: 16px;
    line-height: 1.7;
    margin-bottom: 0;
    @media (max-width: 520px) {
      font-size: 15px;
    }
  }
`;

export default MomentsArea;
